import { Component } from '@angular/core';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent {

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts